export default {
  SIDEBAR_CLICKED: 'Bank Products Sidebar Clicked',
  FILTERED: 'Bank Products Filtered',
  DETAILS_VIEWED: 'Bank Product Details Viewed',
  REPORT_A_PROBLEM_CLICKED: 'Bank Product Report a Problem Clicked',
  REPORT_A_PROBLEM_SENT: 'Bank Product Problem Reported',
  MORTGAGE_AI_CHATBOT_ATTEMPTED: 'Mortgage AI chatbot Attempted',
};
